export var ActivationRequestIssueMethod = "ACTIVATION_REQUEST";
//# sourceMappingURL=types.js.map